import $ from 'jquery';
class Message {
    constructor(){
        if ($("#msg-recipient-list").length != 0){
            this.events();
        }
    }

    events() {
        //$("#msg-all-members").on("change", this.toggleAllMembersSelected.bind(this));

        $("#msg-all-members").on("change", this.toggleAllSelected.bind(this));
        $("#msg-sel-club").on("change", this.checkboxToggle.bind(this));   //  Club Checked
        $("#msg-sel-event").on("change", this.checkboxToggle.bind(this));  //  Event Checked
        $("#msg-sel-member").on("change", this.checkboxToggle.bind(this)); //  Member Checked

        $("#msg-club").on("change", this.dropdownToggle.bind(this));       //  Club Changed
        $("#msg-event").on("change", this.dropdownToggle.bind(this));       //  Event Changed
        $("#msg-member").on("change", this.dropdownToggle.bind(this));       //  Member Changed

        $("#msg-sel-noclub").on("change", this.selectionNoClub.bind(this));
        $("#msg-sel-guest").on("change", this.selectionGuest.bind(this));
        $("#msg-sel-all").on("change", this.selectionAllUsers.bind(this));

        $("#msg-email-copy").on("click", this.copyAllEmails.bind(this));  //  Copy Clicked
    }

    toggleAllSelected(e){
        if ($('#msg-all-members').is(":checked")){
            this.changeCheckboxes(true);
        }
        else {
            this.changeCheckboxes(false);
        }
    }
    changeCheckboxes(checked){
        $('#msg-recipient-list-names input[type="checkbox"]').each(function() {
            ($(this).prop('checked',checked));
        });
    }


    copyAllEmails(e){
        //  First set the text area to only those that have been checked
        storeEmails();
        $("#msg-email-list").removeClass('d-none');
        $("#msg-email-list").trigger('select');
        document.execCommand('copy');
        $("#msg-email-list").addClass('d-none');
    }
    checkboxToggle(e){
        if ($(e.target).is(":checked")){
            $(e.target).closest('.row').find('select').hide();
            $(e.target).closest('.row').find('select').removeClass('d-none');
            $(e.target).closest('.row').find('select').fadeIn(500);
        } else {
            $(e.target).closest('.row').find('select').addClass('d-none');
        }
        this.selectionAll(false);
        this.getData();
    }
    dropdownToggle(e){
        this.getData();
    }
    selectionNoClub(e){
        this.selectionAll(false);
        this.getData();
    }
    selectionGuest(e){
        this.selectionAll(false);
        this.getData();
    }
    selectionAllUsers(e){
        this.selectionAll(true);
        this.getData();
    }
    selectionAll(allSelected){
        if (allSelected){
            //      Turn off all other checkboxes
            $('#msg-recipient-selection input[type="checkbox"]').not($("#msg-sel-all")).each(function() {
                var e=(this.id).replace('sel-','');
                $('#' + e).hide();
                $('#' + e).addClass('d-none');
                $(this).prop('checked',false);
            });
        }
        else {
            $("#msg-sel-all").prop('checked', false);
        }
    }
    getData(){
        var selectionData={};
        if ($('#msg-sel-club').is(":checked") && $('#msg-club').val()!="0"){
            selectionData.club=$('#msg-club').val();
        }
        if ($('#msg-sel-event').is(":checked") && $('#msg-event').val()!="0"){
            selectionData.event=$('#msg-event').val();
        }
        if ($('#msg-sel-member').is(":checked") && $('#msg-member').val()!="0"){
            selectionData.member=$('#msg-member').val();
        }
        if ($('#msg-sel-noclub').is(":checked")){
            selectionData.noclub="TRUE";
        }
        if ($('#msg-sel-guest').is(":checked")){
            selectionData.guest="TRUE";
        }
        if ($('#msg-sel-all').is(":checked")){
            selectionData.all="TRUE";
        }
        if (Object.keys(selectionData).length == 0){
            $('#msg-recipient-list-names').empty();
            $('#msg-all-members').addClass('d-none');
            $('#msg-all-members').prop('checked', false);
        } else {
            $.ajax({
                beforeSend:(xhr) => {
                    xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
                },
                url: dysData.root_url + '/wp-json/dys/v1/messageUsers/',
                data: selectionData,
                type: 'POST',
                success: (response) =>{
                    //  SHOW NAMES
                    this.showMembers(response);
                },
                error: (response) => {
                    console.log("Invalid Data Response");
                    console.log(response);
                }
            });
        }
    }

    showMembers(memberData){
        $('#msg-all-members').prop('checked', true);
        $('#msg-all-members').removeClass('d-none');
        $('#msg-recipient-list-names').empty();
        for (var key in memberData){
            $('#msg-recipient-list-names').append(`<p class="mb-0"><input type="checkbox" checked class="mr-1" name="email::${memberData[key].EMAIL}"></input>${memberData[key].NAME}</p>`);
        }
    }
}
function storeEmails(){
    $("#msg-email-list").val("");
    $('input[type=checkbox]').each(function() {
        if ($(this).is(':checked') && $(this).attr('name')) {
            if ($(this).attr('name').startsWith('email::')){
                addToEmails($(this).attr('name').replace('email::', ''));
            }
        }
    });
}
function addToEmails(email){
    var emailList="";
    emailList = $("#msg-email-list").val();
    emailList += ";" + email;
    //emailList = emailList.substr(0,emailList.length - 1);
    if (emailList.substring(0,1) == ";"){
        emailList = emailList.replace(";","");
    }
    $("#msg-email-list").val(emailList);
}

export default Message;